export const DEFAULT_FIELD_NAMES: Record<string, string> = {
  BR_BOOLEAN: 'booleanValue',
  BR_AMOUNT: 'amountValue',
  BR_DROP_DOWN: 'smallintValue',
  BR_SMALLINT: 'smallintValue',
  BR_NUMERIC: 'numericValue',
  BR_TEXT: 'textValue',
};